import { useMemo } from 'react';
import { ApiClient, EntityCollection, RelatedFile } from '../api/content';
import { createPageQuery, unwrap } from './factory';

export interface TeamMember {
  firstName: string;
  lastName: string;
  jobTitle: string;
  phoneNumber: string;
  email: string;
  photo: RelatedFile;
  reactionPhoto: RelatedFile;
  organization: string;
}

function getTeamMembers(query: string) {
  return ApiClient.get<EntityCollection<TeamMember>>('/team-members', {
    params: {
      filters: {
        $or: {
          0: {
            firstName: {
              $containsi: query,
            },
          },
          1: {
            lastName: {
              $containsi: query,
            },
          },
        },
      },
      sort: {
        lastName: 'asc',
      },
      populate: {
        photo: '*',
        reactionPhoto: '*',
      },
    },
  });
}

export function getTeamMembersQuery(query: string) {
  return createPageQuery({
    queryKey: ['teamMember', query],
    queryFn: unwrap(() => getTeamMembers(query)),
  });
}

export function useTeamMembersQuery(query: string) {
  const { useQuery } = useMemo(() => getTeamMembersQuery(query), [query]);

  return useQuery();
}
